import { forwardRef } from 'react';
import type { BusinessIconImageProps } from '../businessTypes';

type MessageBubbleFilledProps = BusinessIconImageProps & {
  secondaryColor?: string;
};

const MessageBubbleFilled = forwardRef<SVGSVGElement, MessageBubbleFilledProps>(
  ({ size = 24, width, height, alt = '', color = 'currentColor', secondaryColor = '#fff', strokeWidth, style, ...props }, ref) => (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill={color}
      strokeWidth={strokeWidth}
      width={width ?? size}
      height={height ?? size}
      role={alt ? 'img' : undefined}
      aria-label={alt || undefined}
      aria-hidden={alt ? undefined : true}
      style={{ color, ...style }}
      {...props}
    >
      <g transform="translate(-4.235614 -4.741967) scale(1.014704)">
        <path fillRule="evenodd" clipRule="evenodd" d="M16.0003 27.8327C22.2596 27.8327 27.3337 22.7586 27.3337 16.4993C27.3337 10.2401 22.2596 5.16602 16.0003 5.16602C9.7411 5.16602 4.66699 10.2401 4.66699 16.4993C4.66699 18.3255 5.09892 20.0509 5.8662 21.5787C6.65024 23.1399 7.01438 24.862 7.42873 26.5592C7.74799 27.8669 8.78949 27.624 11.233 27.0541C11.4934 26.9933 11.7655 27.0184 12.0159 27.1125C13.2554 27.578 14.5981 27.8327 16.0003 27.8327ZM11.3587 18.3711C11.1022 17.9729 10.5715 17.8581 10.1733 18.1146C9.7751 18.3711 9.66027 18.9019 9.91679 19.3001C11.1758 21.2543 13.4392 22.5398 16.0004 22.5398C18.5616 22.5398 20.825 21.2543 22.084 19.3001C22.3405 18.9019 22.2257 18.3711 21.8275 18.1146C21.4293 17.8581 20.8986 17.9729 20.6421 18.3711C19.7022 19.8299 17.9849 20.8245 16.0004 20.8245C14.0159 20.8245 12.2986 19.8299 11.3587 18.3711Z" />
      </g>
    </svg>
  ),
);

MessageBubbleFilled.displayName = 'MessageBubbleFilled';

export default MessageBubbleFilled;
